import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useParams, useHistory } from "react-router-dom";
import { getIssueGroup, updateIssueGroup } from "../../../../../apis/options/IssueGroupApi";
import moment from "moment";
import { Card } from "react-bootstrap";

const schema = yup
  .object({
    name: yup.string().required(),
    defaultIssueDate: yup.date()
        .transform((value, originalValue) =>
        originalValue === '' ? null : value
        ).nullable().notRequired(),
    defaultStrikePrice: yup.number(),
    defaultNumberOfShares: yup.number().positive().integer(),
    optionTypeId: yup.number().required().integer().positive()
  })
  .required()


const EditIssueGroupForm = () => {

  const [group, setGroup] = useState(null);
  const [isGroupLoading, setGroupLoading] = useState(true);


  let { planId, groupId } = useParams();

  const history = useHistory();

  useEffect(() => {
    async function getGroup(id) {
      try {
        const result = await getIssueGroup(id);
        if(result.defaultIssueDate){
            result.defaultIssueDate = moment(result.startDate).format("yyyy-MM-DD");
        }

        setGroup(result);
        setGroupLoading(false);
      }
      catch(error) {
        setGroupLoading(false);
      }
    }

    getGroup(groupId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const updateHandler = (data) => 
  {
    updateIssueGroup(groupId, data)
    .then(_ => {
      history.push(`/options/plans/${planId}`);
    })
    .catch(() => {
      history.push(`/options/plans/${planId}`);
    });
  }

  const cancelClick = () => {
    history.push(`/options/plans/${planId}`);
  }

  return (
    <>
    {isGroupLoading ?
      <div>Loading...</div> :
      <Card>
        <Card.Title>Edit Issue Group</Card.Title>
        <Card.Text>
          <Form noValidate 
              onSubmit={handleSubmit(updateHandler)}>
                
              <Form.Group>
                <Form.Label>Issue Group Name</Form.Label>
                <Form.Control defaultValue={group.name} isInvalid={!!errors.name} type="text" placeholder="Issue Group Name" {...register("name")} />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Grant Date</Form.Label>
                <Form.Control defaultValue={group.defaultIssueDate} isInvalid={!!errors.defaultIssueDate} type="date" placeholder="Default Grant Date" {...register("defaultIssueDate")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultIssueDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Strike Price</Form.Label>
                <Form.Control defaultValue={group.defaultStrikePrice} isInvalid={!!errors.defaultStrikePrice} type="text" placeholder="Default Strike Price" {...register("defaultStrikePrice")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultStrikePrice?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Default Number of Shares</Form.Label>
                <Form.Control defaultValue={group.defaultNumberOfShares} isInvalid={!!errors.defaultNumberOfShares} type="text" placeholder="Default Number of Shares" {...register("defaultNumberOfShares")} />
                <Form.Control.Feedback type="invalid">
                  {errors.defaultNumberOfShares?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Option Type</Form.Label>
                <Form.Control value="1" readOnly isInvalid={!!errors.optionTypeId} type="text" placeholder="Option Type" {...register("optionTypeId")} />
                <Form.Control.Feedback type="invalid">
                  {errors.optionTypeId?.message}
                </Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit">Save</Button>
              <Button variant="secondary" onClick={cancelClick}>Cancel</Button>
          </Form> 
        </Card.Text>
      </Card>
    }
    </>

  );
}

export default EditIssueGroupForm;